export default __webpack_public_path__ + "static/media/GreenTick.f54e7ba3.svg";